import styled from 'styled-components'
import PropTypes from 'prop-types'

import { container } from '@h2/components/mixins'
import { PB97T, WHITE } from '@h2/components/colors'

const Wrap = styled.div`
  transition: all 0.3s ease-in-out;
  width: 100%;
  ${container};
  padding: 0;
`
const Outer = styled.div`
  background-color: ${PB97T};
`
const AnimatedContainer = ({ children, unconstrained, bgColor = WHITE }) => {
  return (
    <Outer>
      <Wrap bgColor={bgColor} inDialog={unconstrained}>
        {children}
      </Wrap>
    </Outer>
  )
}

AnimatedContainer.propTypes = {
  bgColor: PropTypes.string,
  unconstrained: PropTypes.bool,
  children: PropTypes.node.isRequired
}

export { AnimatedContainer }
